import Button from '../UI/Button/Button';
import Input from '../UI/Input/Input';
import styles from './RegiserForm.module.css';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { userService } from '../../services/user.service';
import { useDispatch } from 'react-redux';
import { setAuth } from '../../redux/slices/auth';
import Alert from '../UI/Alert/Alert';
import { toast } from 'react-toastify';

function RegisterForm({ onGoToLogin }) {
    const { t } = useTranslation('auth');
    const { t: tValidation } = useTranslation('validation');
    const [email, setEmail] = useState({ value: '', error: null });
    const [password, setPassword] = useState({ value: '', error: null });
    const [confirmPassword, setConfirmPassword] = useState({ value: '', error: null });
    const [generalError, setGeneralError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [verificationSent, setVerificationSent] = useState(false);
    const dispatch = useDispatch();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setEmail({ value: email.value, error: null });
        setPassword({ value: password.value, error: null });
        setConfirmPassword({ value: confirmPassword.value, error: null });
        try {
            const response = await userService.registerUser({
                email: email.value,
                password: password.value,
                confirmPassword: confirmPassword.value
            });

            if (response.status === 'verification_required') {
                setVerificationSent(true);
                return;
            }

            if (response.status === 'success') {
                dispatch(setAuth({ user: response.user }));
                toast.success(tValidation('user_registered_successfully'));
            }

        } catch (error) {
            const errorEntity = error?.payload?.error;
            if (errorEntity && Array.isArray(errorEntity)) {
                errorEntity.forEach(error => {
                    if (error.path[0] === 'email') {
                        setEmail({ value: email.value, error: error });
                    }
                    if (error.path[0] === 'password') {
                        setPassword({ value: password.value, error: error });
                    }
                    if (error.path[0] === 'confirmPassword') {
                        setConfirmPassword({ value: confirmPassword.value, error: error });
                    }
                });
            }
            else if (typeof errorEntity === 'string') {
                const message = tValidation(errorEntity.toString());
                setGeneralError(message);
                toast.error(message);
            } else {
                toast.error(tValidation('something_went_wrong'));
            }
        } finally {
            setIsLoading(false);
        }
    };

    if (verificationSent) {
        return (
            <div className={styles.formContainer}>
                <img
                    src={`${process.env.PUBLIC_URL}/assets/menu-logo-name-only.png`}
                    alt="Logo"
                    className={styles.logo}
                />
                <div className={styles.verificationState}>
                    <p className={styles.verificationTitle}>{t('verification.check_your_email_title')}</p>
                    <p className={styles.verificationMessage}>{t('verification.check_your_email_message')}</p>
                    <button type="button" className={styles.goToLoginBtn} onClick={onGoToLogin}>
                        {t('verification.go_to_login')}
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.formContainer}>
            <img
                src={`${process.env.PUBLIC_URL}/assets/menu-logo-name-only.png`}
                alt="Logo"
                className={styles.logo}
            />
            <form className={styles.form} onSubmit={handleSubmit}>
                {generalError && <Alert type="error">{generalError}</Alert>}
                <Input
                    type="email"
                    placeholder={t('register.email')}
                    value={email.value} onChange={(e) => setEmail({ value: e.target.value, error: null })}
                    error={email.error}
                />
                <Input
                    type="password"
                    placeholder={t('register.password')}
                    value={password.value} onChange={(e) => setPassword({ value: e.target.value, error: null })}
                    error={password.error}
                />
                <Input
                    type="password"
                    placeholder={t('register.confirmPassword')}
                    value={confirmPassword.value}
                    onChange={(e) => setConfirmPassword({ value: e.target.value, error: null })}
                    error={confirmPassword.error}
                />
                <Button variant="primary" type="submit" disabled={isLoading}>{t('register.register')}</Button>
            </form>
        </div>
    );
}

export default RegisterForm;
